import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import './main.css';

import BottomTabBar from './components/ui/BottomTabBar';
import DesktopNav from './components/ui/DesktopNav';

// Eager-loaded pages (critical path)
import HomePage  from './pages/HomePage';
import WatchPage from './pages/WatchPage/WatchPage';

// Lazy-loaded pages
const SearchPage     = lazy(() => import('./pages/SearchPage'));
const ProfilePage    = lazy(() => import('./pages/ProfilePage'));
const CategoryPage   = lazy(() => import('./pages/CategoryPage'));
const CategoriesPage = lazy(() => import('./pages/WatchPage/CategoriesPage/CategoriesPage'));
const VideosPage     = lazy(() => import('./pages/VideosPage'));
const CommentsPage   = lazy(() => import('./pages/CommentsPage'));
const StudioPage     = lazy(() => import('./pages/StudioPage'));
const ProducerPage   = lazy(() => import('./pages/ProducerPage'));
const LoginPage      = lazy(() => import('./pages/LoginPage'));
const AdminPage      = lazy(() => import('./pages/AdminPage'));
const Dmca           = lazy(() => import('./pages/Dmca'));
const ContactPage    = lazy(() => import('./pages/ContactPage'));

const Loader = () => (
    <div style={{ display: 'flex', justifyContent: 'center', padding: '60px 0' }}>
        <div className="hb-spinner" />
    </div>
);

const HIDE_TAB_BAR = ['/admin', '/login'];

function Layout() {
    const { pathname } = useLocation();
    const hideBar = HIDE_TAB_BAR.some(p => pathname.startsWith(p));

    return (
        <>
            {!hideBar && <DesktopNav />}
            <Suspense fallback={<Loader />}>
                <Routes>
                    <Route path="/"                   element={<HomePage />} />
                    <Route path="/watch/:id"           element={<WatchPage />} />
                    <Route path="/search"              element={<SearchPage />} />
                    <Route path="/profile"             element={<ProfilePage />} />
                    <Route path="/videos"               element={<VideosPage />} />
                    <Route path="/comments"            element={<CommentsPage />} />
                    <Route path="/categories"          element={<CategoriesPage />} />
                    <Route path="/categories/:slug"    element={<CategoryPage />} />
                    <Route path="/studio/:slug"        element={<StudioPage />} />
                    <Route path="/producer/:slug"      element={<ProducerPage />} />
                    <Route path="/login"               element={<LoginPage />} />
                    <Route path="/dmca"                element={<Dmca />} />
                    <Route path="/contacts"           element={<ContactPage />} />
                    <Route
                        path="/admin"
                        element={
                            localStorage.getItem('isAdmin')
                                ? <AdminPage />
                                : <div style={{ padding: '2rem', color: '#e60073' }}>Доступ запрещён</div>
                        }
                    />
                </Routes>
            </Suspense>
            {!hideBar && <BottomTabBar />}
        </>
    );
}

export default function App() {
    return (
        <Router>
            <Layout />
        </Router>
    );
}
